<template>
<div class="content">
    <div class="container-fluid">
    <div class="row">
        <div class="col-md-12">
        <leave-approval>
        </leave-approval> 
        </div>
    </div>  
    </div>
</div>
</template>
<script>
/* eslint-disable */
import leaveApproval from './todo-leave-approval'
export default {
    components: {
        leaveApproval
    }
}
</script>
<style lang="scss">
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-leave-management/base-leave-approval.vue